/**
 * Shared commerce tenant constants — safe to import from both server and client.
 *
 * Kept separate from `resolver.ts` (which carries the server-leaning registry) so
 * the D2C designer surface can detect "are we in D2C mode?" on the client without
 * pulling in resolution logic. The `NEXT_PUBLIC_` env is read first so the client
 * bundle and the server agree on the same tenant id; the non-public env is the
 * server-only override; the literal is the launch default.
 */

/** The default consumer storefront (no retailerId) — the Plantista garden center. */
export const DEFAULT_TENANT_ID = "00000000-0000-0000-0000-000000000000";

/** Fossil Creek Nursery. */
export const FOSSIL_CREEK_RETAILER_ID = "e955b2c5-d47d-4ae4-971f-36ed0deb87f2";

/**
 * Plantista's own D2C storefront — served by our Shopify store (D-9 decision:
 * "D2C tenant = Shopify"). Overridable via env so the real tenant id can be set
 * without a code change. Distinct from DEFAULT_TENANT_ID so seeding Shopify here
 * does NOT change the existing (live, Stripe) garden-center checkout.
 */
export const D2C_STOREFRONT_TENANT_ID =
  process.env.NEXT_PUBLIC_D2C_STOREFRONT_TENANT_ID ||
  process.env.D2C_STOREFRONT_TENANT_ID ||
  "d2c00000-0000-4000-8000-000000000d2c";

/**
 * The retailer whose catalog (recipes + genus_aliases) actually backs the D2C
 * designer. The D2C storefront tenant (D2C_STOREFRONT_TENANT_ID) selects the
 * Shopify commerce connection, but the plants the designer surfaces live under
 * the Plantista garden-center retailer. When resolving prices/SKUs for a D2C
 * request whose own retailerId returns an empty alias map, callers retry the
 * catalog lookup with THIS id. Defaults to the Plantista GC (DEFAULT_TENANT_ID
 * today); overridable via env once the real GC uuid is set.
 */
export const PLANTISTA_GC_RETAILER_ID =
  process.env.NEXT_PUBLIC_PLANTISTA_GC_RETAILER_ID ||
  process.env.PLANTISTA_GC_RETAILER_ID ||
  DEFAULT_TENANT_ID;
